import React, { useState } from "react"
import { Container } from "@bootstrap-styled/v4"

import { World as Global } from "@styled-icons/boxicons-regular"

import * as S from "./styles.js"

const LanguagesButton = () => {
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <Container
      style={{ position: "absolute", left: 0, display: "block" }}
      as="li"
    >
      <>
        <S.LanguagesButtonWrapper>
          <S.Button onClick={() => setIsExpanded(old => !old)}>
            <Global color={`#fff`} size={38} />
            <span>pt</span>
          </S.Button>

          <S.Popup isVisible={isExpanded} onClick={() => setIsExpanded(false)}>
            <S.LanguageOption
              className={`active`}
              aria-label="Selecionar idioma português"
              name="Selecionar idioma português"
            >
              <div className="flag">🇧🇷</div>
              <span>Português</span>
            </S.LanguageOption>
          </S.Popup>
        </S.LanguagesButtonWrapper>
      </>
    </Container>
  )
}

export default LanguagesButton
